/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Store/StorePermissionService',[
    'jquery',
    'lodash',
    'global/Core',
    'global/Extensions',
    'global/Logger'
], function ($, _, Core, Extensions, Logger) {
    'use strict';

    function clearCookies() {
        Core.eraseCookie('is_B2B_status_approved');
        Core.eraseCookie('can_see_pricing');
    }

    function isLoggedIn() {
        return Core.getCookie('access_token') !== null;
    }

    function isApprovedB2BUser() {
        return Core.getCookie('is_B2B_status_approved') === 'True';
    }

    function hasSeePricingPermission() {
        return Core.getCookie('can_see_pricing') === 'True';
    }

    /**
     *  Determines whether the current user can see "Add to cart" button.
        When a user is not logged in, the Add to Cart button should be replaced with a Login for Pricing 
        and this should redirect customers to the registration page.
     * @returns {} 
     */
    function canAddToCart() {
        return isLoggedIn();
    }

    /**
     * Determines whether the current user can see product pricing.
     * Pricing is available for logged-in users only.
     * @returns {} 
     */
    function canSeePricing() {
        return true;
    }

    /**
     * Determines whether the current user can see cart Delivery options.
     * Cart delivery options is available for logged-in approved users only.
     * @returns {} 
     */
    function canSeeCartDeliveryOptions() {
        return isLoggedIn() && isApprovedB2BUser();
    }

    /**
     * Determines whether the current user can checkout. 
     */
    function canCheckout(cart) {
        if (!(isLoggedIn() && isApprovedB2BUser()) || cart === undefined || cart === null ||
            cart.customFields === undefined || cart.customFields === null ||
            cart.items === undefined || cart.items === null || cart.items.length === 0) {
            return false;
        }

        var isQuoteOnly = Extensions.getAttributeValue(cart.customFields, 'isQuoteOnly');
        return isLoggedIn() && isApprovedB2BUser() && !isQuoteOnly;
    }

    /**
     * Determines whether the current user can request a quote instead of checking out.
     */
    function canRequestQuote(cart) {
        var isQuotedCart = cart.customFields && cart.customFields.quoteId;
        return isLoggedIn() &&
            isApprovedB2BUser() &&
            cart !== undefined &&
            cart !== null &&
            cart.items !== undefined &&
            cart.items !== null &&
            cart.items.length > 0 &&
            !isQuotedCart;
    }


    var StorePermissionService = {
        canAddToCart: canAddToCart,
        canSeePricing: canSeePricing,
        canSeeCartDeliveryOptions: canSeeCartDeliveryOptions,
        canCheckout: canCheckout,
        canRequestQuote: canRequestQuote,
        clearCookies: clearCookies
    };

    Logger.debug('StorePermissionService.js Loaded:', StorePermissionService);

    return StorePermissionService;
});
